import React from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { MONTH_LABELS, WEEKS_PER_MONTH } from './categories'

const REAL_TIME = 'real'

const POSITIONS = MONTH_LABELS.flatMap((month, monthIndex) =>
  Array.from({ length: WEEKS_PER_MONTH }, (_, week) => ({
    value: monthIndex * WEEKS_PER_MONTH + week,
    label: `${month} · W${week + 1}`,
  }))
)

type Props = {
  week: number | null
  onChange: (week: number | null) => void
}

// Outside production only: moves the now-line, not the dates the service uses.
const PlanTimeSimulator = ({ week, onChange }: Props) => (
  <FormControl size="small" sx={{ minWidth: 200, m: 0 }}>
    <InputLabel id="plan-time-simulator">Test: plan position</InputLabel>
    <Select
      labelId="plan-time-simulator"
      label="Test: plan position"
      value={week === null ? REAL_TIME : String(week)}
      onChange={(event) => onChange(event.target.value === REAL_TIME ? null : Number(event.target.value))}
    >
      <MenuItem value={REAL_TIME}>Today (real time)</MenuItem>
      {POSITIONS.map(({ value, label }) => (
        <MenuItem key={value} value={String(value)}>
          {label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)

export default PlanTimeSimulator
